export const tilesConstant = {
    childHeaderText: 'Predictive Maintenance Plan',
};
